import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=516e08c5&scoped=true&"
import script from "./GoodsList.vue?vue&type=script&lang=js&"
export * from "./GoodsList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=516e08c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516e08c5",
  null
  
)

export default component.exports